import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Mousewheel, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import ph1 from '../assets/01.webp';
import ph2 from '../assets/02.webp';
import ph3 from '../assets/03.webp';
import ph4 from '../assets/04.webp';
import ph5 from '../assets/05.webp';
import ph6 from '../assets/06.webp';

// Sample image URLs - you can replace these with your actual images
const slideImages = [
  ph1, ph2, ph3, ph4, ph5, ph6
];

// Moon dot icon for pagination
const moonDotImage = [
  ph1, ph2, ph3, ph4, ph5, ph6
];

function CustomCarousel() {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const totalSlides = 6;

  // Handle dot click
  const handleDotClick = (index) => {
    if (swiperInstance) {
      swiperInstance.slideTo(index);
    }
  };

  return (
    <div className="carousel-wrapper">
      {/* Custom dot pagination on the left */}
      <div className="custom-pagination">
        {moonDotImage.map((image, index) => (
          <div
            key={index}
            className={`pagination-dot ${activeIndex === index ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
          >
            <img src={image} alt={`Dot ${index + 1}`} />
          </div>
        ))}
      </div>


      {/* Phone mockup with carousel */}
      <div className="phone-mockup">
        <Swiper
          direction="vertical"
          slidesPerView={1}
          spaceBetween={30}
          mousewheel={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[Pagination, Mousewheel, Autoplay]}
          className="vertical-swiper"
          onSwiper={setSwiperInstance}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        >
          {slideImages.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="phone-screen green">
                <img src={image} alt={`Slide ${index + 1}`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
            </SwiperSlide>
          ))}

        </Swiper>
      </div>

      <style jsx>{`
        .carousel-wrapper {
          display: flex;
          align-items: center;
          position: relative;
          height: 510px;
        }

        .custom-pagination {
          position: absolute;
          left: 20px;
          display: flex;
          flex-direction: column;
          gap: 20px;
          z-index: 10;
        }

        .pagination-dot {
          width: 31px;
          height: 53px;
          opacity: 0.5;
          cursor: pointer;
          transition: all 0.3s ease;
          border-radius: 8px;
        }

        .pagination-dot img {
          width: 100%;
          height: 100%;
        }

        .pagination-dot.active {
          opacity: 1;
          height: 63px;
          width :40px;
          padding:5px;
          border: 2px solid #4CAF50;
          // background-color: #f0fff0;
        }

        .phone-mockup {
              margin-left: 135px;
               width: 220px;
              height: 458px;
              //  border: 10px solid black;
              border-radius: 25px;
              overflow: hidden;
               position: relative;
        }

        .phone-mockup::before {
          content: "";
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          // width: 80px;
          // height: 20px;
          // background-color: black;
          // border-bottom-left-radius: 10px;
          // border-bottom-right-radius: 10px;
          z-index: 100;
        }

        .vertical-swiper {
          height: 100%;
          width: 100%;
        }

        .phone-screen {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          // color: white;
        }

        // .green {
        //   background-color: green;
        // }

        .content {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .quran-logo {
          width: 60px;
          height: 60px;
          // background-color: white;
          margin-bottom: 10px;
        }

        .quran-text {
          // background-color: white;
          color: black;
          padding: 2px 10px;
          font-size: 16px;
          font-weight: bold;
        }
          @media(max-width: 639px){
           .phone-mockup{
            margin-left:75px;
           }
          }
           @media(max-width:320px){
            .phone-mockup{
                   width:155px;
                   height : 437px;
               }
           }

      `}</style>
    </div>
  );
}

export default CustomCarousel;